import React from 'react';
function TimePicker(props) {
  const { name, value, onChange, error } = props;

  const startHour = 8;
  const endHour = 18;

  return (
    <div className="lg:mt-0 w-12/12 lg:w-9/12 mt-4 md:mt-0 text-left">
      <label
        htmlFor={name}
        className="text-sm lg:text-lg flex justify-start lg:justify-left"
      >
        Time
      </label>

      <select
        name={name}
        className="w-full h-10 rounded-[10px] border-[2px] border-[#cfd1d6]  p-2  bg-transparent focus:outline-2 focus:outline-[#B70303]"
        onChange={onChange}
        value={value || ''}
      >
        <option value="">Select time</option>
        {Array.from(
          { length: endHour - startHour + 1 },
          (_, i) => i + startHour
        ).map((hour) => (
          <React.Fragment key={hour}>
            <option value={`${hour}:00`}>
              {hour % 12 || 12}:00 {hour < 12 ? 'AM' : 'PM'}
            </option>
            {hour !== endHour && (
              <option value={`${hour}:30`}>
                {hour % 12 || 12}:30 {hour < 12 ? 'AM' : 'PM'}
              </option>
            )}
          </React.Fragment>
        ))}
      </select>

      {error && <div className="text-[#B70303]">{error}</div>}
    </div>
  );
}

export default TimePicker;
